import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/cloud-off.vue
var s = {
	name: "DtIconCloudOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--cloud-off"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Cloud Off",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		fill: "currentColor"
	}, [...t[0] || (t[0] = [i("path", { d: "M4.505 2.463a.5.5 0 0 1 .567-.423A4.004 4.004 0 0 1 8.209 4.5h.54a2.75 2.75 0 0 1 2.465 3.972.5.5 0 1 1-.896-.444A1.75 1.75 0 0 0 8.75 5.5h-.895a.5.5 0 0 1-.48-.357A3.004 3.004 0 0 0 4.929 3.03a.5.5 0 0 1-.423-.567ZM.646.646a.5.5 0 0 1 .708 0l10 10a.5.5 0 0 1-.708.708l-1.398-1.4A2.683 2.683 0 0 1 8.75 10H4.5a4 4 0 0 1-2.405-7.198L.646 1.354a.5.5 0 0 1 0-.708Zm.938 6.064a3 3 0 0 1 1.228-3.191L8.292 9H4.5a3 3 0 0 1-2.916-2.29Z" }, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=cloud-off.js.map